export default __webpack_public_path__ + "static/mob-health-ios-56770762ba9e315dc376a58a50564996.png";